import config from '@config'
import usePageMetadata from '@hooks/usePageMetadata'
import { mobileCSS } from '@measures/responsive'
import { SocialProps } from '@widgets/SocialShare/types'
import GamificationButton from '@components/Buttons/GamificationButton'
import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'
import Copy from './Copy'
import Mail from './Email'
import Facebook from './Facebook'
import Twitter from './Twitter'
import Whatsapp from './Whatsapp'
import EndOfArticleContext from '@contexts/endOfArticle'
import { stripHtml } from '@hooks/useTracking/utils'
import Print from '@components/Social/Print'
import useIsInRecipeContent from '@hooks/useIsInRecipeContent'
import { printCSS } from '@utils/style'

const {
  backend: { baseUrl },
} = config

const StyledSocial = styled.div<{ isInRecipe: boolean; endOfArticle: boolean }>`
  ${({ isInRecipe, endOfArticle }) => css`
    display: flex;
    justify-content: space-between;
    flex: 1;
    ${printCSS(css`
      display: none;
    `)}

    ${mobileCSS(css`
      align-self: flex-start;
    `)}
    margin: ${isInRecipe && !endOfArticle
      ? '16px 8px 16px 0'
      : '8px 8px 8px 0'};
  `}
`

const SocialButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
`

const Social: FunctionComponent<SocialProps> = ({ endOfArticle }) => {
  const pageMetadata = usePageMetadata()
  const articleUrl = pageMetadata?.url
  const articleId = pageMetadata?.id
  const isInRecipe = useIsInRecipeContent()

  if (!articleUrl || !articleId) {
    return null
  }

  const { catchword, title } = pageMetadata

  const shareUrl = `${baseUrl}${articleUrl}`
  const shareTitle = stripHtml(`${catchword ? `${catchword}:` : ''}${title}`)

  return (
    <EndOfArticleContext.Provider value={endOfArticle}>
      <StyledSocial isInRecipe={isInRecipe} endOfArticle={endOfArticle}>
        <SocialButtonsContainer>
          <Facebook shareUrl={shareUrl} />
          <Twitter shareUrl={shareUrl} shareTitle={shareTitle} />
          <Whatsapp shareUrl={shareUrl} shareTitle={shareTitle} />
          <Mail shareUrl={shareUrl} shareTitle={shareTitle} />
          <Copy />
          {isInRecipe && <Print />}
        </SocialButtonsContainer>
        <GamificationButton />
      </StyledSocial>
    </EndOfArticleContext.Provider>
  )
}

export default Social
